import styled from 'styled-components/macro';

import DatePicker from '@mui/lab/DatePicker';

const StyledDatePicker = styled(DatePicker)``;

export {StyledDatePicker};
